import template from './unauthorized.html';
import './unauthorized.scss';
/**
 * Shows the _"unauthorized"_ screen.
 * @ngesdoc component
 * @ngname unauthorized
 * @ngmodule auth
 * @ngbinding {string}  subtitle A subtitle to place under the Olapic logo. Usually the name of the
 *                               app the user can't access to.
 * @ngbinding {boolean} loading  Whether or not the component should show a loading indicator.
 */
export default {
  template,
  bindings: {
    subtitle: '<',
    loading: '<',
  },
};
